<template>
	<div class="gap-3 tw-flex">
		<AppButton
			:label="$t('whatsapp.assign-category')"
			variant="gray"
			secondary
			size="md"
			@click="categoryStore.isOpenAssignCategoriesWhatsDialog = true"
			:disabled="isDisabled()"
		/>

		<AppButton
			startIcon="assets/v2/image/icons/plus.svg"
			:label="$t('whatsapp.add-new-category')"
			variant="brand"
			size="md"
			@click="categoryStore.isOpenCategoryDialog = true"
			:disabled="isDisabled()"
		/>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCategoryStore } from '@/v2/modules/whatsapp/stores/categories';
import Category from '@/v2/modules/whatsapp/entities/categories';
import { useTableStore } from '@/v2/store/shared/table-store';

const router = useRouter();
const categoryStore = useCategoryStore();
const tableStore = useTableStore({
	tableName: 'categories',
	fetchDataFunction: Category.fetch,
});

const isDisabled = ()=> {
    if(categoryStore.hasFilters) return true;
    return tableStore.loading || tableStore.data.length > 9;
}

</script>

<style lang="scss" scoped></style>
